//auth slice
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {
    user_id: null,
    user_username: null,
    user_first_name: null,
    user_last_name: null,
    user_role_id: null,
    user_role_name: null,
  },
  token: null,
  refreshToken: null,
  permissions: [],
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.user = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setRefreshToken: (state, action) => {
      state.refreshToken = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    logout: (state) => {
      state.user = initialState.user;
      state.token = initialState.token;
      state.refreshToken = initialState.refreshToken;
      state.permissions = initialState.permissions;
    },
  },
});

const selectors = {
  getUser: (state) => state.auth.user,
  getToken: (state) => state.auth.token,
  getRefreshToken: (state) => state.auth.refreshToken,
  getPermissions: (state) => state.auth.permissions,
  isAuthenticated: (state) => !!state.auth.token,
};

export const authSlice = {
  reducer: slice.reducer,
  actions: slice.actions,
  selectors,
};

export default authSlice;
